<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-book-reader_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">コース管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'course' }">戻る</router-link>
    </div>
    <div class="container">
      <label>コース凍結 ー </label>
      <label class="label lb-red">注意：この作業はスタッフ二人以上で確認の上実行してください</label>
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">法人名（法人ID）：</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）：</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">コース名（コースID）：</th>
            <td>合格{{ currentCourse.testPassingScore }}点コース ({{ currentCourse.uid }})</td>
          </tr>
          <tr>
            <th scope="row">凍結開始月：</th>
            <td>
              <v-select
                tag="div"
                v-model="frozenMonth"
                placeholder="選択してください"
                class="custom-select mr-sm-2"
                id="inlineFormCustomSelect-2"
                style="width: 180px;"
                :clearable="false"
                :options="frozenMonthJPs"
                :reduce="(option) => option.value"
                label="text"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table">
        <tbody>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-0"
                  v-model="noStudentChecked"
                />
                <label class="custom-control-label" for="column-display-check-0">
                  このコースに関連づけられている全てのクラスは、クラスの変更を実行しました。
                  <br />
                  もしくは、生徒が一人も紐づけられていないクラスだけが紐づけられていることを確認しました。
                </label>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-1"
                  v-model="noContinueStudyingChecked"
                />
                <label class="custom-control-label" for="column-display-check-1">
                  実行していない場合、このコースに所属しているクラス、及びそのクラスに含まれる生徒も凍結処理されます。
                  <br />
                  この場合、学習できなくなる生徒が現れる可能性があることを理解しています。
                </label>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
      <div class="m-5 text-center">
        <button
          type="button"
          class="btn btn-red"
          @click="confirmFrozen"
          :disabled="!frozenMonth || !noStudentChecked || !noContinueStudyingChecked"
        >
          凍結実行
        </button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="一覧に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>コース凍結</template>
        <template v-slot:body>コースの凍結、または凍結予約が完了しました</template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { basicCorporationNameIdPresent, basicBrandNameIdPresent } from '@/presenters/fields';
import { nextNMonthJPs } from '@/utils/year_helpers';
import { nextNDayJPs } from '@/utils/date_helpers';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    PopUpHolder,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('course/fetchCourse', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  data() {
    return {
      frozenMonth: null,
      noStudentChecked: false,
      noContinueStudyingChecked: false,
    };
  },
  computed: {
    currentCourse() {
      return this.course.course;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentCourse.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentCourse.brand);
    },
    frozenMonthJPs() {
      let numberOfMonths = 12;
      let arrayOfMonths = [];
      if (Vue.config.stagingBuild) {
        arrayOfMonths = nextNDayJPs(numberOfMonths);
      } else {
        arrayOfMonths = nextNMonthJPs(numberOfMonths);
      }
      arrayOfMonths.unshift({
        value: 'now',
        text: '今すぐ凍結',
      });
      return arrayOfMonths;
    },
    ...mapState(['course']),
  },
  methods: {
    confirmFrozen() {
      this.$logger.debug('Confirm frozen');
      let payload = {
        id: this.currentCourse.id,
        frozenMonth: this.frozenMonth,
      };
      this.freezeCourse(payload).then(() => {
        this.$logger.debug('Show success popup');
        this.$refs['popup_holder'].show();
      });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      this.$router.push({ name: 'course' });
    },
    ...mapActions('course', ['freezeCourse']),
  },
};
</script>

<style scoped>
.btn-red {
  margin-left: 0px;
}
.lb-red {
  color: red;
  margin-left: 5px;
}
.custom-control-label {
  font-weight: normal;
  font-size: 13px;
}
</style>
